import * as Sentry from '@sentry/react';
import { ApiError } from './client';
// One endpoint = one Sentry issue: replace id-ish path segments (uuids, hex,
// numbers) with :id and drop the query string, so '/study/<uuid>/images?x=1'
// and '/study/<other-uuid>/images' group together.
export function normalizeEndpointKey(key) {
    const path = key.split('?')[0];
    return path
        .split('/')
        .map((segment) => (/^(\d+|[0-9a-f]{8,}(-[0-9a-f]{4,}){0,4})$/i.test(segment) ? ':id' : segment))
        .join('/');
}
// Failed API calls the user actually experienced: network failures (status 0)
// and server faults (>=500). EVERY 4xx — 400 validation, 401 session expiry
// (login redirect), 403/404/409 — is treated as a handled UX state (toast,
// inline error, redirect) and stays out of Sentry. Anything non-ApiError
// escaping the data layer is a programming error and is always captured.
export function shouldCaptureApiError(error) {
    if (error instanceof ApiError) {
        return error.status === 0 || error.status >= 500;
    }
    return true;
}
export function captureApiError(error, context) {
    if (!shouldCaptureApiError(error))
        return;
    const isApiError = error instanceof ApiError;
    const normalizedKey = context.key ? normalizeEndpointKey(context.key) : undefined;
    Sentry.captureException(error, {
        tags: {
            api_source: context.source,
            ...(isApiError ? { http_status: String(error.status) } : {}),
            ...(normalizedKey ? { endpoint: normalizedKey } : {}),
        },
        // ApiErrors all throw from the same client.ts frames, so stack-based
        // grouping would collapse every endpoint into one issue — fingerprint by
        // endpoint + status instead. Non-ApiErrors keep default stack grouping.
        ...(isApiError
            ? { fingerprint: ['api-error', normalizedKey ?? 'unknown', String(error.status)] }
            : {}),
    });
}
